import React, { useEffect, useState } from 'react';

const Footer = () => {
  const apiUrl = import.meta.env.VITE_API_URL; // Adjust as needed
  const [data, setData] = useState({ socials: [] });

  useEffect(() => {
    fetch(`${apiUrl}/layout/footer/`) // Replace with actual path or API endpoint
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((error) => console.error("Error loading footer data:", error));
  }, [apiUrl]);

  return (
    <footer
      className="font-bold p-2 shadow-xl bg-black text-white"
      style={{ backgroundColor: data.bgColor, color: data.textColor }}
    >
      <div className="footer flex flex-col lg:flex-row gap-0   lg:items-center">
        {/* Social media links section */}
        <div className="social-icons flex lg:flex-col gap-6 justify-center mt-6 mx-auto lg:mr-10 lg:ml-20">
          {data.socials.map((social) => (
            <a
              key={social.link}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon rounded-full  hover:bg-gray-200 transition duration-300"
            >
              <img
                src={social.icon}
                className="w-12 lg:w-16 hover:scale-110 rounded-full object-cover"
                alt="Social Icon"
              />
            </a>
          ))}
        </div>

        {/* Addresses Section */}
        <div className="addresses flex flex-col lg:flex-row gap-8 justify-center mt-8 mx-10 lg:ml-20">
          {data.addresses && data.addresses.length > 0 ? (
            <div className="address-container flex flex-wrap gap-2 justify-center w-full">
              {data.addresses.map((address, index) => (
                <div key={index} className="address-box p-2 bg-gray-800 text-white rounded-xl shadow-md flex-1 w-96">
                  <h6 className="font-bold text-lg mb-2">{address.heading}</h6>
                  <p className="text-xs mb-3 text-wrap">{address.detail}</p>
                  {address.email && <p className="text-xs">Email: <a href={`mailto:${address.email}`} className="text-alf hover:text-blue-300">{address.email}</a></p>}
                  {address.phoneNumber && <p className="text-xs">Phone: <a href={`tel:${address.phoneNumber}`} className="text-alf hover:text-blue-300">{address.phoneNumber}</a></p>}
                </div>
              ))}
            </div>
          ) : (
            <p>No addresses available.</p>
          )}
        </div>
      </div>

      <div className="copyright text-center mt-8 text-xs text-gray-400">
        <p>&copy; {data.copyText}</p>
      </div>
    </footer>
  );
};

export default Footer;
